<template>
  <div class="booking-card">
    <h1>book now</h1>
    <form action="
    ">
      <label for="room-type">ROOM TYPE</label>
      <div id="room-type">{{roomData.room[0].name}}</div>
      <label for="name">
        NAME
        <i class="fas fa-exclamation-circle alert" v-show="!reserver"></i>
      </label>
      <input id="name" type="text" v-model="reserver" />
      <label for="tel">
        TEL.
        <i class="fas fa-exclamation-circle alert" v-show="!reserverTel"></i>
      </label>
      <input id="tel" type="tel" v-model="reserverTel" />
      <div class="check-date">
        <div class="check-in">
          <label for="checkIn">
            CHECK IN
            <i class="fas fa-exclamation-circle alert" v-show="!reservationStartDate"></i>
          </label>
          <div id="checkIn">{{ reservationStartDate }}</div>
        </div>
        <div class="check-out">
          <label for="checkOut">
            CHECK OUT
            <i class="fas fa-exclamation-circle alert" v-show="!reservationEndDate"></i>
          </label>
          <div id="checkOut">{{ reservationEndDate }}</div>
        </div>
      </div>
    </form>
    <Calendar :bookedDates="bookedDates"></Calendar>
    <button
      class="bookBtn"
      @click="submitForm"
      :disabled="!formCompleted"
      :class="{disabled:!formCompleted}"
    >Submit</button>
    <div class="alert submit-alert" :class="{hide:formCompleted}">
      <i class="fas fa-exclamation-circle"></i> Form Incompleted
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Calendar from "@/components/Calendar.vue";
export default {
  props: {},
  components: {
    Calendar
  },
  computed: {
    ...mapState(["reservationStartDate", "reservationEndDate", "roomData"]),
    bookedDates() {
      const ar = [];
      this.roomData.booking.forEach(obj => {
        const ymd = obj.date.split("-");
        ar.push(new Date(ymd[0], ymd[1] - 1, ymd[2]));
      });
      return ar;
    },
    reserver: {
      get() {
        return this.$store.state.reserver;
      },
      set(value) {
        this.$store.commit("UPDATE_RESERVER", value);
      }
    },
    reserverTel: {
      get() {
        return this.$store.state.reserverTel;
      },
      set(value) {
        this.$store.commit("UPDATE_RESERVER_TEL", value);
      }
    },
    reservationStartDate: {
      get() {
        if (!this.$store.state.reservationStartDate) {
          return "";
        }
        return `${this.$store.state.reservationStartDate.getFullYear()}-${this.$store.state.reservationStartDate.getMonth() +
          1}-${this.$store.state.reservationStartDate.getDate()}`;
      },
      set(value) {
        this.$store.commit("SET_RESERVATION_DATE", value);
      }
    },
    reservationEndDate: {
      get() {
        if (!this.$store.state.reservationEndDate) {
          return "";
        }
        return `${this.$store.state.reservationEndDate.getFullYear()}-${this.$store.state.reservationEndDate.getMonth() +
          1}-${this.$store.state.reservationEndDate.getDate()}`;
      },
      set(value) {
        this.$store.commit("SET_RESERVATION_DATE", value);
      }
    },
    formCompleted() {
      if (!this.reserver) {
        return false;
      }
      if (!this.reserverTel) {
        return false;
      }
      if (!this.reservationStartDate) {
        return false;
      }
      if (!this.reservationEndDate) {
        return false;
      }
      return true;
    }
  },
  methods: {
    submitForm() {
      if (!this.formCompleted) {
        return;
      }
      this.$store.dispatch("submitReservationForm");
      this.$router.push("/reservationResult");
      this.$store.commit("RESET_RESERVATION_DATE");
    }
  }
};
</script>

<style lang="scss" scoped>
h1 {
  text-align: center;
}
.booking-card {
  padding: var(--g-xxl) calc(2 * var(--g-xxl));
  border-radius: var(--g-m);
  margin: 45px var(--g-xxl);
  box-shadow: 0 0 4px var(--text-color-lightest);
  display: flex;
  flex-flow: column wrap;
  width: 375px;
}
form {
  display: flex;
  flex-flow: column nowrap;
  margin: var(--g-xl) 0;
  font-size: var(--fs-s);
  label {
    font-weight: bold;
  }
  #room-type,
  input {
    font-size: var(--fs-m);
    width: 100%;
    outline: none;
    border: 0;
    border-bottom: 2px solid var(--text-color-darker);
    margin-bottom: var(--g-xxl);
    margin-top: var(--g-s);
  }
  #room-type {
    text-transform: uppercase;
  }
  .check-date {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    .check-in,
    .check-out {
      width: 45%;
    }
    height: 45px;
  }
  #checkIn,
  #checkOut {
    font-size: var(--fs-m);
    width: 100%;
    outline: none;
    border: 0;
    border-bottom: 2px solid var(--text-color-darker);
    margin-top: var(--g-l);
    text-align: center;
    height: 20px;
  }
}
.bookBtn {
  &:hover {
    cursor: pointer;
  }
  &:active {
    background-color: var(--text-color-lightest);
    color: var(--text-color-darker);
  }
  position: relative;
  border: none;
  outline: none;
  background-color: black;
  text-transform: uppercase;
  color: white;
  font-weight: bold;
  padding: var(--g-s) var(--g-m);
  align-self: flex-end;
  border-radius: var(--g-s);
  font-size: var(--fs-m);
  &.disabled {
    cursor: initial;
  }
}
.alert {
  //   color: var(--color-alert);
  font-size: var(--fs-s);
  font-weight: bold;
  text-align: right;
  &.submit-alert {
    margin: var(--g-m) 0 0 0;
    transition: opacity 0.5s;
  }
}
.hide {
  opacity: 0;
}
</style>